import React, { Dispatch, SetStateAction } from 'react';

import { Box, Divider, Drawer } from '@mui/material';

import { Decision } from '../../../../common/constants/decision';
import { Resource } from '../../../../common/constants/resource';
import { IDecision } from '../../interfaces/IDecision';
import DrawerHeader from '../DrawerHeader';
import styles from '../styles.module.scss';
import IneligibleForm from './IneligibleForm';
import { IneligibleFormData } from './useIneligibleForm';

const EditIneligible = ({
  isOpen,
  setIsOpen,
  isUpdate,
  editedDecision,
  onSuccess,
  initialFormData,
  onDecisionChanged,
}: {
  isOpen: boolean;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
  isUpdate: boolean;
  editedDecision?: IDecision;
  onSuccess: (formData: IneligibleFormData) => void;
  initialFormData?: IneligibleFormData | null;
  onDecisionChanged?: (decision: Decision) => void;
}) => (
  <Drawer
    open={isOpen}
    anchor="right"
    variant="persistent"
    classes={{ paper: styles.Drawer }}
    transitionDuration={{ enter: 0, exit: 0 }}
  >
    <DrawerHeader
      title={
        isUpdate
          ? Resource.UPDATE_DECISION_HEADER
          : Resource.INELIGIBLE_APPLICATION_HEADER
      }
      onClose={() => setIsOpen(false)}
    />
    <Divider />
    <Box m={3}>
      <IneligibleForm
        editedDecision={editedDecision}
        onDecisionChanged={onDecisionChanged}
        initialFormData={initialFormData}
        isOpen={isOpen}
        onSuccess={onSuccess}
        isUpdate={isUpdate}
      />
    </Box>
  </Drawer>
);

export default EditIneligible;
